import React from "react";

const Info = () => {
    return (
        <div className="articles__wrapper__info">
            <h2 className="heading-tag">Latest Articles</h2>
        </div>
    );
};

export default Info;
